var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEmailFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99796 6.80441C8.27649 6.80441 8.53465 6.67208 8.83356 6.36564L14.7439 0.369124C14.4925 0.118398 14.0238 0 13.3512 0H2.41372C1.84307 0 1.44226 0.111434 1.21807 0.341265L7.16236 6.36564C7.45448 6.66512 7.71264 6.80441 7.99796 6.80441ZM0.654212 10.8787L5.4572 6.01045L0.640625 1.14219C0.538723 1.3372 0.484375 1.6715 0.484375 2.15206V9.84097C0.484375 10.3355 0.538723 10.6837 0.654212 10.8787ZM15.3213 10.8717C15.43 10.6698 15.4844 10.3285 15.4844 9.84097V2.15206C15.4844 1.68543 15.43 1.35113 15.3349 1.16309L10.5319 6.01045L15.3213 10.8717ZM2.61753 12H13.555C14.1257 12 14.5197 11.8886 14.7439 11.6657L9.84579 6.69298L9.39742 7.15961C8.92867 7.61927 8.48709 7.82821 7.99796 7.82821C7.50204 7.82821 7.06046 7.61927 6.59851 7.15961L6.14334 6.69298L1.25883 11.6587C1.51698 11.8886 1.96535 12 2.61753 12Z",
    fill: "#838AA1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmailFilled);
export default __webpack_public_path__ + "static/media/icon-email-filled.689862ef61cf5390164d9d281f66a11f.svg";
export { ForwardRef as ReactComponent };